export default {
  carta: "CARTA",
  yourLastOrders: "TUS ÚLTIMOS PEDIDOS",
  productOrderNotAvailable:
    "Lo sentimos, el producto que está solicitando no está disponible.",
  noOrders: "Aún no tienes pedidos",
  updated: "Actualizado!",
  updatingzClosuresSummaryCollection:
    "Actualizando la colección de resumen de zClosures ...",
  updateOrdersAndPaymentSummariesCollection:
    "Actualizando pedidos y cobranza de resúmenes de pagos ...",
  whatDishesAre: "¿Qué platos son",
  theMaximumNumberOfProductAllowed: "El máximo de productos permitido son 20",
  orderPlaced: "Pedido Realizado",
  updatePaymentsCollection: "Actualización de la cobranza de pagos ..."
};
